<template>
	<div class="mb_db learner_program_requirment">

		<div class="row">
      <div class="col-12">
        <template v-if="program">

					<div class="row status_row">
      			<div class="col-6 hd_txt">
							My Program Status
						</div>
						<div class="col-6 program_status_select_bx">
							<div class="selected_val">
								<div class="val in_progress" v-if="enrollmentStatus === 'INPROGRSS'">In Progress</div>
								<div class="val completed" v-if="enrollmentStatus === 'COMPLETED'">Completed</div>
								<div class="val not_complete" v-if="enrollmentStatus === 'NOTCOMPLETED'">Couldn't Complete</div>
								<div class="ic ic22-dropdown2"></div>
							</div>
<!-- DO Not Allow Chaning the status from this page
							<select class="form-control" v-model="enrollmentStatus" @change="changeEnrollmentStatus">
								<option class="" value="INPROGRSS">In Progress</option>
								<option class="" value="COMPLETED">Completed</option>
								<option class="" value="NOTCOMPLETED">Couldn't Complete</option>
							</select>
-->
						</div>
					</div>


						<div class="row">
							<div class="col-12 lnk_container">
								<a href="javascript://" @click="navigateToRequirements">Requirements</a>
							</div>
						</div>

				</template>
        <template v-else>
          <b-card class="text-center prog-lmi">

						<template #header>
							<div class="hd_ic">

							</div>
        			<div class="hd_txt">
								My Program Status
							</div>
      			</template>

						<div class="crd_content">
	            <b-card-text>
	              <div class="mt-5">
	                <span>Program requirement data not available.</span>
	              </div>
	            </b-card-text>
						</div>

						<div class="lnk_container">

						</div>

          </b-card>
        </template>
      </div>
    </div>

	</div>
</template>

<script>
	import { mapState, mapActions } from 'vuex'

	export default {
		name: 'learner-program-requirement',
    props: ['program'],
    data: () => {
      return {
        enrollmentStatus: 'NOTENROLLED',
      }
    },
    computed: {
    	...mapState({
    		'userObject': state => state.login.userObj
	    })
	  },
	  beforeMount () {
	  	this.enrollmentStatus = this.userObject.enrollmentStatus
	  },
		methods: {
			...mapActions([
	      'loadSaveEnrollmentStatus'
	    ]),
			navigateToRequirements () {
        let routerParams = {
          cipCode: this.program.cipCode,
          programGuideCode: this.program.code,
          type: this.program.type
        }
        return this.$router.push({name: 'programGuideRequirements', params: routerParams, query: {returnTo: 'learnerDashboard'}})
      },
      roundedValue (value, precision) {
        let multiplier = Math.pow(10, precision || 1)
        let rounded = Math.round(value * multiplier) / multiplier
        return rounded.toFixed(precision || 1)
      },
      async changeEnrollmentStatus () {
        let currentUserObj = this.userObject
        if('NOTENROLLED' === this.enrollmentStatus && 'NOTENROLLED' === currentUserObj.enrollmentStatus){
          return
        }
        if('NOTENROLLED' === this.enrollmentStatus){
          currentUserObj.major1 = undefined
        }else{
          currentUserObj.major1 = this.program.code
        }
        currentUserObj.enrollmentStatus = this.enrollmentStatus
        await this.loadSaveEnrollmentStatus({programCode: this.program.code, status: this.enrollmentStatus})
        this.$root.$emit('reloadLearnerDashboard')
      }
		}
	}
</script>

<style scoped>
  .prog-req .card-header {
    height: 65px;
    padding-top: 0px;
  }
</style>



// WEBPACK FOOTER //
// src/app/dashboard/components/LearnerProgramRequirement.vue